import { ApiResponseOne } from "../shared/types/responses";

import { CommissionCalculationResponse } from "../shared/types/commission-calculation.type";
import hvpAuthenticatedApi from "../api/hvpAuthenticatedApi";

import { BaseService } from "./base.service";
import { convertDatesToDayJS, convertDatesToString } from "../shared/helpers";
import { AxiosParams } from "../shared/types";
import {
  CommissionAllocationFormValues,
  CommissionAllocationRequest,
  CommissionAllocationResponse,
} from "../shared/types/commission-allocation.type";
import { CommissionStatsResponse } from "../shared/types/commission-stats.type";
import { CommissionsPromotionStatsResponse } from "../shared/types/commission-promotion-stats.type";
import { CommissionsCollaboratorStatsResponse } from "../shared/types/commission-collaborator-stats.type";

const API_URL = "/commission-allocations";
export class CommissionAllocationService extends BaseService<
  CommissionAllocationRequest,
  CommissionAllocationResponse,
  CommissionAllocationFormValues
> {
  constructor() {
    super(API_URL);
  }

  public transformResponseToFormValues(
    response: CommissionAllocationResponse
  ): CommissionAllocationFormValues {
    return convertDatesToDayJS(response);
  }

  public async getCommissionCalculation(
    params?: AxiosParams
  ): Promise<ApiResponseOne<CommissionCalculationResponse>> {
    const response = await hvpAuthenticatedApi.get<
      ApiResponseOne<CommissionCalculationResponse>
    >(`${API_URL}/commission-calculation`, { params });
    return response.data;
  }

  public async getCommissionStats(
    params?: AxiosParams
  ): Promise<ApiResponseOne<CommissionStatsResponse>> {
    const response = await hvpAuthenticatedApi.get<
      ApiResponseOne<CommissionStatsResponse>
    >(`${API_URL}/stats`, { params });
    return response.data;
  }

  public async getPromotionStats(
    params?: AxiosParams
  ): Promise<ApiResponseOne<CommissionsPromotionStatsResponse>> {
    const response = await hvpAuthenticatedApi.get<
      ApiResponseOne<CommissionsPromotionStatsResponse>
    >(`${API_URL}/promotion-stats`, { params });
    return response.data;
  }

  public async getCollaboratorStats(
    collaboratorId: string,
    params?: AxiosParams
  ): Promise<ApiResponseOne<CommissionsCollaboratorStatsResponse>> {
    const response = await hvpAuthenticatedApi.get<
      ApiResponseOne<CommissionsCollaboratorStatsResponse>
    >(`${API_URL}/stats/${collaboratorId}`, { params });
    return response.data;
  }
}
